export default __webpack_public_path__ + "static/media/sms-blue-icon.7c56b2d6.svg";